import CovidPortal from '@/views/CovidPortal/index.vue'

const CovidPortalRouter = {
  path: '/covid-portal',
  name: 'CovidPortal',
  component: CovidPortal,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default CovidPortalRouter
